import {
  ADD_PROMO_ITEM,
  ADD_To_CART,
  APPLY_PROMO,
  CLEAR_CART,
  EDIT_BOOKING,
  EDIT_CART,
  EDIT_CART_PROMO_ITEM,
  EDIT_OPTION,
  EDIT_PRODUCT,
  EDIT_QUANTITY,
  EDIT_QUANTITY_PROMO,
  REDUCE_QUANTITY,
  REMOVE_FROM_CART,
  REMOVE_FROM_CART_PROMO_ITEM,
  SET_CATEGORIES_MIN_ORDER,
  SET_IS_PREORDERING_FALSE,
  SET_NON_MINGLED_CATEGORY,
  SET_PREP_AND_LEAD_TIME,
  SET_SMART_PROMOS,
  UPDATE_PROMOTION,
} from "../actions/actionTypes";
import instance from "../actions/instance";
import { getParentCategories } from "../../Components/Menu/Helpers";
import moment from "moment";
import { getProduct } from "./store";

const initialState = {
  cart: [],
  price: 0,
  delivered_items: 0,
  charged_items: 0,
  pickup_only_items: 0,
  delivery_only_items: 0,
  cash_only_items: 0,
  credit_only_items: 0,
  promos: null,
  smart_promos: [],
  discounts: {
    percent: [],
    fixed: [],
    delivery: [],
    products: [],
    category: [],
    products_percent: [],
    modifier: [],
    category_free: [],
    cashback_fixed: [],
    cashback_percent: [],
  },
  promo_items: [],
  preparation_time: 0,
  number_of_items: 0,
  mingled_item: false,
  categories_min_order: {},
  preordered_items: 0,
  preordering_max_leadtime: 0,
  non_mingled_category: null,
  payment_method: "none",
};

const resetState = {
  cart: [],
  price: 0,
  delivered_items: 0,
  charged_items: 0,
  pickup_only_items: 0,
  delivery_only_items: 0,
  cash_only_items: 0,
  credit_only_items: 0,
  promos: null,
  smart_promos: [],
  discounts: {
    percent: [],
    fixed: [],
    delivery: [],
    products: [],
    category: [],
    products_percent: [],
    modifier: [],
    category_free: [],
    cashback_fixed: [],
    cashback_percent: [],
  },
  promo_items: [],
  preparation_time: 0,
  number_of_items: 0,
  mingled_item: false,
  categories_min_order: {},
  preordered_items: 0,
  preordering_max_leadtime: 0,
  non_mingled_category: null,
  payment_method: "none",
};

export const preciseNumber = (number) => {
  return parseFloat(number.toPrecision(7));
};

let getPromoItemPriceExcludingModifiers = (options, excludedModifiers) => {
  let promoTotalPrice = 0;
  let promoQuantityExclusivePrice = 0;

  Object.entries(options).forEach(([optionID, option]) => {
    Object.entries(option.selectedOptions).forEach(([choiceID, choice]) => {
      if (excludedModifiers.includes(choice.modifier)) {
        if (option.quantityExclusive) {
          promoQuantityExclusivePrice += choice.price * choice.quantity;
        } else {
          promoTotalPrice += choice.price * choice.quantity;
        }
      }
    });
  });

  return { promoTotalPrice, promoQuantityExclusivePrice };
};

function options_are_equal(product1, product2) {
  let keys = Object.keys(product1.selectedOptions);
  let keys_2 = Object.keys(product2.selectedOptions);
  keys = [...new Set(keys.concat(keys_2))];
  let duplicates = false;
  for (const key of keys) {
    if (
      product2.selectedOptions[key] &&
      product1.selectedOptions[key] &&
      product1.selectedOptions[key].quantity ===
        product2.selectedOptions[key].quantity
    ) {
      duplicates = true;
      continue;
    } else {
      duplicates = false;
      break;
    }
  }
  return duplicates;
}

function convertToJS(data) {
  let d = data.replace(new RegExp("'", "g"), '"');
  d = d.replace(new RegExp("None", "g"), "null");
  d = d.replace(new RegExp("False", "g"), "false");
  d = d.replace(new RegExp("True", "g"), "true");
  return JSON.parse(d);
}

function getItemPrepTime(item, cart) {
  let prepTime = item.preparation_time;

  if (item.preparation_time_threshold) {
    const totalItemQuantity = cart.reduce(
      (total, cartItem) =>
        cartItem.id === item.id ? total + cartItem.quantity : total,
      0
    );
    prepTime =
      (Math.ceil(totalItemQuantity / item.preparation_time_threshold) || 1) *
      prepTime;
  }
  Object.values(item.options).forEach((option) => {
    Object.values(option.selectedOptions).forEach((choice) => {
      if (choice.preparationTime != null && choice.preparationTime > prepTime) {
        prepTime = choice.preparationTime;
      }
    });
  });

  return prepTime || 0;
}

function calculate_preordering_leadtime(cart) {
  let leadTime = 0;
  cart.forEach((item) => {
    if (item.preordering_leadtime > leadTime) {
      leadTime = item.preordering_leadtime;
    }
  });
  return leadTime;
}

export function calculate_prep_time(cart, sumProductPrepTime) {
  let prepTime = 0;
  let totalSumOfPrepTime = 0;

  cart.forEach((item) => {
    const itemPrepTime = getItemPrepTime(item, cart);
    if (itemPrepTime > prepTime && !sumProductPrepTime) {
      prepTime = itemPrepTime;
    } else {
      totalSumOfPrepTime += itemPrepTime;
    }
  });
  return sumProductPrepTime ? totalSumOfPrepTime : prepTime;
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function CheckDuplicate2(product, payload, is_promo_item = false) {
  if (!isEmpty(payload.extraFields) || !isEmpty(product.extraFields))
    return false;
  if (payload.resource) return false;
  let group_keys = Object.keys(payload.options);
  let duplicates = false;
  if (
    group_keys.length &&
    Object.keys(product.options).length === group_keys.length
  ) {
    for (const group_key of group_keys) {
      if (
        product.options[group_key] &&
        options_are_equal(
          payload.options[group_key],
          product.options[group_key]
        )
      ) {
        duplicates = true;
        continue;
      } else {
        duplicates = false;
        break;
      }
    }
  } else if (isEmpty(payload.options) && isEmpty(product.options)) {
    duplicates = true;
  }
  if (duplicates && (payload.special_request || product.special_request)) {
    if (payload.special_request !== product.special_request) duplicates = false;
  }
  if (duplicates && payload.booking_slot) {
    if (payload.booking_slot !== product.booking_slot) duplicates = false;
  }
  if (duplicates && is_promo_item) {
    if (
      payload.promo !== product.promo ||
      payload.discount !== product.discount
    )
      duplicates = false;
  }

  if (duplicates && payload.is_preordered !== product.is_preordered) {
    duplicates = false;
  }
  return duplicates;
}

function GetCartQuantity(product, cart) {
  let quantity = 0;
  cart.forEach((p) => {
    if (
      (!product.has_variants && p.id === product.product) ||
      (product.has_variants && p.parent === product.product)
    ) {
      quantity += p.quantity;
    }
  });
  return quantity;
}

function CheckPromoProducts(products, cart, multiplier, conditionQuantity) {
  let cartQuantity = products.reduce(
    (quantity, product) => GetCartQuantity(product, cart) + quantity,
    0
  );
  if (conditionQuantity * multiplier > cartQuantity) {
    return [false, parseInt(cartQuantity / conditionQuantity)];
  }
  return [true, parseInt(cartQuantity / conditionQuantity)];
}

function async_add_promo_item(
  categories,
  promoProduct,
  quantity,
  promo,
  asyncDispatch,
  smartPromos
) {
  const product = getProduct(
    categories,
    promoProduct.product,
    promoProduct.category_id,
    promoProduct.parent
  );
  const canAdd =
    !["bookable", "service"].includes(product.type_of_product) &&
    !product.has_variants &&
    !product.has_required_options &&
    !product.has_required_extra_fields &&
    !product.no_mingling &&
    !product.pickup_only &&
    !product.delivery_only &&
    !product.cash_only &&
    !product.credit_only &&
    !product.extra_fields.some((field) => field.is_required) &&
    (!product.published_date ||
      moment(product.published_date).isBefore(moment()));
  if (!canAdd) {
    return;
  }
  let parentCategories = null;
  if (product.category_is_child) {
    parentCategories = getParentCategories(product.category_id, categories);
  }

  if (["stocked", "composite"].includes(product.type_of_product)) {
    quantity = Math.min(quantity, product.inventory_on_hand);
  }

  if (quantity <= 0) return;
  let cartProduct = {
    id: product.id,
    quantity: quantity,
    category: product.category,
    category_id: product.category_id,
    options: {}, //
    booking_slot: null,
    parent: product.parent,
    total_price: 0,
    price: 0,
    is_delivered: product.is_delivered,
    charge_delivery: product.charge_delivery,
    special_request: "",
    preparation_time: product.preparation_time,
    preparation_time_threshold: product.preparation_time_threshold,
    no_mingling: product.no_mingling,
    pickup_only: product.pickup_only,
    delivery_only: product.delivery_only,
    cash_only: product.cash_only,
    credit_only: product.credit_only,
    is_preordered: false,
    preordering_leadtime: 0,
    resource: null,
    resourceSlot: null,
    extraFields: {},
    quantityExcludedOptionsTotal: 0,
    name: product.name,
    category_is_child: product.category_is_child,
    category_no_mingling: product.category_no_mingling,
    parentCategories: parentCategories,
    publishedDate: product.published_date,
    excludeVat: product.exclude_from_vat,

    promo: promo,
    discount: promoProduct.id,
  };

  asyncDispatch({
    type: ADD_PROMO_ITEM,
    payload: cartProduct,
    smart_promos: smartPromos || [],
  });
  asyncDispatch({
    type: REDUCE_QUANTITY,
    payload: { product: cartProduct, change: quantity },
  });
}

function switchToFreeProduct(
  cart,
  discountObject,
  quantity,
  promo,
  discount,
  asyncDispatch,
  discountType = "category_free"
) {
  let removedItemsCount = 0;
  let freeQuantity = quantity;
  cart.forEach((cartItem, productIndex) => {
    if (
      (discountType === "category_free" &&
        discountObject.includes(cartItem.category_id)) ||
      discountObject.product === cartItem.id
    ) {
      const usedQuantity = Math.min(cartItem.quantity, freeQuantity);
      freeQuantity = freeQuantity - usedQuantity;
      let payload = {
        ...cartItem,
        quantity: usedQuantity,
        total_price: 0,
        price: 0,
        promo: promo.id,
        discount: discount,
        discountType: discountType,
        parentCategories: null,
      };
      asyncDispatch({
        type: ADD_PROMO_ITEM,
        payload: payload,
        smart_promos: [],
      });
      if (usedQuantity === cartItem.quantity) {
        asyncDispatch({
          type: REMOVE_FROM_CART,
          payload: productIndex - removedItemsCount,
          smart_promos: [],
        });
        removedItemsCount++;
      } else {
        asyncDispatch({
          type: EDIT_QUANTITY,
          payload: {
            product: productIndex - removedItemsCount,
            quantity: cartItem.quantity - usedQuantity,
          },
          smart_promos: [],
        });
      }
    }
  });
  return freeQuantity;
}
export function isNotExcludedProuduct(
  product,
  excludedProducts,
  excludedCategories
) {
  if (
    excludedCategories.includes(product.category_id) ||
    excludedProducts.some(
      (excludedProduct) =>
        product.id === excludedProduct || product.parent === excludedProduct
    )
  ) {
    return false;
  }

  return true;
}

function getItemTotalExcludeModifiers(product, excludedModifiers) {
  let options = product.options;
  let extras = product.extraFields;
  let productTotal = product.price * product.quantity;

  Object.values(options).forEach((option) => {
    Object.values(option.selectedOptions).forEach((choice) => {
      if (!excludedModifiers.includes(choice.modifier)) {
        productTotal +=
          choice.quantity *
          choice.price *
          (option.quantityExclusive ? 1 : product.quantity);
      }
    });
  });

  Object.values(extras).forEach((extra) => {
    productTotal +=
      extra.price * (extra.quantityExclusive ? 1 : product.quantity);
  });

  return preciseNumber(productTotal);
}

export function getTotalExcludeProducts(
  cart,
  excludedProducts,
  excludedCategories,
  excludedModifiers
) {
  let total = 0;
  let quantity = 0;

  cart.forEach((item) => {
    if (isNotExcludedProuduct(item, excludedProducts, excludedCategories)) {
      if (excludedModifiers.length) {
        total += getItemTotalExcludeModifiers(item, excludedModifiers);
      } else {
        total +=
          item.total_price * item.quantity + item.quantityExcludedOptionsTotal;
      }
      quantity += item.quantity;
    }
  });
  return [total, quantity];
}

export function getCategoryTotal(
  cart,
  categories_ids,
  excludedProducts,
  excludedCategories,
  excludedModifiers,
  storeCategories
) {
  let total = 0;
  let quantity = 0;

  cart.forEach((item) => {
    let parentCategories = [];
    if (item.category_is_child) {
      parentCategories = getParentCategories(
        item.category_id,
        storeCategories
      ).parentCategories;
    }

    if (
      (categories_ids.includes(item.category_id) ||
        (parentCategories.length &&
          categories_ids.some((c) => parentCategories.includes(c)))) &&
      isNotExcludedProuduct(item, excludedProducts, excludedCategories)
    ) {
      if (excludedModifiers.length) {
        total += getItemTotalExcludeModifiers(item, excludedModifiers);
      } else {
        total +=
          item.total_price * item.quantity + item.quantityExcludedOptionsTotal;
      }
      quantity += item.quantity;
    }
  });
  return [total, quantity];
}

function ShouldAddPromo(
  smart_promos,
  NewSmart_promos,
  NewDiscounts,
  newPrice,
  NewNumber_of_items,
  NewCart,
  NewPromoItems,
  asyncDispatch,
  newMingled_item,
  newAppliedCoupon,
  customerAddress,
  branchDetails,
  authUser,
  storeCategories,
  storeSettings,
  deliveryTime,
  customerBin
) {
  let add_promo;
  let multiplier;
  let existing_promo;
  let new_quantity;
  const serviceTypes = { 0: "delivery", 1: "pickup" };
  const deliveryArrivalTime = { asap: "asap", scheduled: "scheduled" };

  smart_promos.forEach((promo) => {
    existing_promo = NewSmart_promos.find((p) => p.id === promo.id);
    if (!existing_promo || (existing_promo && existing_promo.repeatable)) {
      add_promo = true;
      new_quantity = Infinity;
      if (existing_promo) multiplier = existing_promo.quantity + 1;
      else multiplier = 1;
      let totalPrice = newPrice;
      let totalItems = NewNumber_of_items;
      if (
        promo.excluded_products.length ||
        promo.excluded_categories.length ||
        promo.excluded_modifiers.length
      ) {
        [totalPrice, totalItems] = getTotalExcludeProducts(
          NewCart,
          promo.excluded_products,
          promo.excluded_categories,
          promo.excluded_modifiers
        );
      }

      for (let i = 0; i < promo.conditions.length; i++) {
        if (
          promo.conditions[i].type === "value" &&
          totalPrice >= promo.conditions[i].value * multiplier
        ) {
          new_quantity = Math.min(
            new_quantity,
            parseInt(totalPrice / promo.conditions[i].value)
          );
          continue;
        } else if (
          promo.conditions[i].type === "number" &&
          totalItems >= promo.conditions[i].value * multiplier
        ) {
          new_quantity = Math.min(
            new_quantity,
            parseInt(totalItems / promo.conditions[i].value)
          );
          continue;
        } else if (promo.conditions[i].type === "products") {
          let [condition, tmp_quantity] = CheckPromoProducts(
            promo.conditions[i].products,
            NewCart,
            multiplier,
            promo.conditions[i].value
          );

          if (condition) {
            new_quantity = Math.min(new_quantity, tmp_quantity);
            continue;
          }
        } else if (
          promo.conditions[i].type === "coupon" &&
          newAppliedCoupon &&
          newAppliedCoupon.id === promo.id
        ) {
          continue;
        } else if (promo.conditions[i].type === "category_value") {
          let [categoryTotalPrice, _] = getCategoryTotal(
            NewCart,
            promo.conditions[i].categories?.ids,
            promo.excluded_products,
            promo.excluded_categories,
            promo.excluded_modifiers,
            storeCategories
          );

          if (categoryTotalPrice >= promo.conditions[i].value * multiplier) {
            new_quantity = Math.min(
              new_quantity,
              parseInt(categoryTotalPrice / promo.conditions[i].value)
            );
            continue;
          }
        } else if (promo.conditions[i].type === "category_number") {
          let [_, cateogryTotalItems] = getCategoryTotal(
            NewCart,
            promo.conditions[i].categories?.ids,
            promo.excluded_products,
            promo.excluded_categories,
            promo.excluded_modifiers,
            storeCategories
          );

          if (cateogryTotalItems >= promo.conditions[i].value * multiplier) {
            new_quantity = Math.min(
              new_quantity,
              parseInt(cateogryTotalItems / promo.conditions[i].value)
            );
            continue;
          }
        } else if (
          promo.conditions[i].type === "service_type" &&
          customerAddress &&
          serviceTypes[customerAddress.selectedDeliveryType] ===
            promo.conditions[i].value
        ) {
          continue;
        } else if (
          promo.conditions[i].type === "delivery_arrival_time" &&
          deliveryTime?.type &&
          deliveryArrivalTime[deliveryTime?.type] === promo.conditions[i].value
        ) {
          continue;
        } else if (promo.conditions[i].type === "delivery_area") {
          let area_id;

          if (customerAddress?.selectedDeliveryType === 0) {
            if (branchDetails?.branch) {
              area_id = branchDetails.bdc;
            } else {
              area_id = customerAddress.area;
            }
          }

          if (area_id && promo.conditions[i].value?.ids.includes(area_id)) {
            continue;
          }
        } else if (promo.conditions[i].type === "branch") {
          let branch_id;
          if (branchDetails?.branch) {
            branch_id = branchDetails.branch;
          } else if (customerAddress?.selectedDeliveryType === 1) {
            branch_id = customerAddress.pickupArea;
          }

          if (branch_id && promo.conditions[i].value?.ids.includes(branch_id)) {
            continue;
          }
        } else if (promo.conditions[i].type === "country") {
          let country_id = customerAddress?.country;

          if (
            country_id &&
            promo.conditions[i].value?.ids.includes(country_id)
          ) {
            continue;
          }
        } else if (
          promo.conditions[i].type === "points" &&
          authUser?.points >= promo.conditions[i].value &&
          newAppliedCoupon &&
          newAppliedCoupon.id === promo.id
        ) {
          continue;
        } else if (promo.conditions[i].type === "orders") {
          if (authUser && authUser.orders_count === promo.conditions[i].value) {
            continue;
          }
        } else if (promo.conditions[i].type === "orders_more") {
          if (authUser && authUser.orders_count > promo.conditions[i].value) {
            continue;
          }
        } else if (promo.conditions[i].type === "orders_less") {
          if (authUser && authUser.orders_count < promo.conditions[i].value) {
            continue;
          }
        } else if (promo.conditions[i].type === "first_time") {
          if (
            authUser &&
            authUser.orders_count <= 0 &&
            moment(authUser.created).isAfter(moment(promo.created))
          ) {
            continue;
          }
        } else if (promo.conditions[i].type === "card_scheme") {
          if (
            promo.conditions[i].value?.toLowerCase() ===
            customerBin?.card_scheme?.toLowerCase()
          ) {
            continue;
          }
        } else if (promo.conditions[i].type === "card_bank") {
          if (
            (tapBanks[promo.conditions[i].value] || []).includes(
              customerBin?.bank?.toLowerCase()
            )
          ) {
            continue;
          }
        }
        add_promo = false;
        break;
      }

      if (
        add_promo &&
        !authUser &&
        promo.discounts.some((d) =>
          ["cashback_fixed", "cashback_percent"].includes(d.type)
        )
      ) {
        add_promo = false;
      }

      if (
        promo.quantity_per_user >= 1 &&
        (!authUser || promo.quantity_per_user <= promo.user_quantity_used)
      ) {
        add_promo = false;
      }

      if (
        existing_promo &&
        promo.remaining + existing_promo.quantity < new_quantity
      ) {
        add_promo = false;
      } else if (!existing_promo) {
        new_quantity = Math.min(new_quantity, promo.remaining);

        if (new_quantity <= 0) {
          add_promo = false;
        }
      }
      if (promo.repeatable) {
        new_quantity = Math.min(
          new_quantity,
          promo.maximum_number_of_repetitions
        );
        if (existing_promo?.quantity === new_quantity) {
          add_promo = false;
        }
      }

      if (
        storeSettings?.allow_one_promo &&
        (NewSmart_promos.length >= 1 || newAppliedCoupon) &&
        ((newAppliedCoupon &&
          (!newAppliedCoupon.isSmartPromo ||
            newAppliedCoupon?.id != promo.id)) ||
          NewSmart_promos.some((p) => p.id > promo.id))
      ) {
        add_promo = false;
        new_quantity = 0;
      }
      if (add_promo) {
        if (!existing_promo) {
          NewSmart_promos.push({
            id: promo.id,
            repeatable: promo.repeatable,
            quantity: !promo.repeatable ? 1 : new_quantity,
            version: promo.version,
            applyForCash: promo.apply_for_cash,
            bypassMOV: promo.bypass_minimum_order,
          });
          promo.remaining -= !promo.repeatable ? 1 : new_quantity;
        } else {
          promo.remaining -= new_quantity - existing_promo.quantity;
          existing_promo.quantity = new_quantity;
        }

        promo.discounts.forEach((discount) => {
          if (discount.type === "delivery" && !existing_promo) {
            NewDiscounts.delivery.push({
              id: discount.id,
              promo: promo.id,
              type: "delivery",
              value: 100,
              discount_amount: 100,
            });
            NewDiscounts.delivery.sort(function (a, b) {
              return (b.value || 100) - (a.value || 100);
            });
          } else if (discount.type === "delivery_percent" && !existing_promo) {
            NewDiscounts.delivery.push({
              id: discount.id,
              promo: promo.id,
              type: "delivery_percent",
              value: discount.value,
              discount_amount: !promo.repeatable
                ? discount.value
                : discount.value * new_quantity,
            });
            NewDiscounts.delivery.sort(function (a, b) {
              return (b.value || 100) - (a.value || 100);
            });
          } else if (discount.type === "fixed" && !existing_promo) {
            if (!NewDiscounts.fixed.length) {
              NewDiscounts.fixed.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.fixed.length; i++) {
                if (discount.value >= NewDiscounts.fixed[i].value) {
                  NewDiscounts.fixed.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.fixed.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "percent" && !existing_promo) {
            if (!NewDiscounts.percent.length) {
              NewDiscounts.percent.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.percent.length; i++) {
                if (discount.value >= NewDiscounts.percent[i].value) {
                  NewDiscounts.percent.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.percent.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "products" && discount.products) {
            discount.products.forEach((product) => {
              if (!existing_promo) {
                NewDiscounts.products.push({
                  ...product,
                  original_quantity: product.quantity,
                  quantity: !promo.repeatable
                    ? product.quantity
                    : product.quantity * new_quantity,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                  promo: promo.id,
                });
                if (promo.auto_add_free_products) {
                  const hasProductRelatedConditions = smart_promos.some(
                    (sp) =>
                      NewSmart_promos.map((nsp) => nsp.id).includes(sp.id) &&
                      sp.conditions.some((c) =>
                        [
                          "value",
                          "number",
                          "products",
                          "category_value",
                          "category_number",
                        ].includes(c.type)
                      )
                  );
                  let freeQuantityLeft = product.quantity;
                  if (!hasProductRelatedConditions) {
                    freeQuantityLeft = switchToFreeProduct(
                      NewCart,
                      product,
                      product.quantity,
                      promo,
                      product.id,
                      asyncDispatch,
                      "products"
                    );
                  }
                  if (freeQuantityLeft > 0) {
                    async_add_promo_item(
                      storeCategories || [],
                      product,
                      freeQuantityLeft,
                      promo.id,
                      asyncDispatch,
                      smart_promos
                    );
                  }
                }
              } else {
                let product_promo = NewDiscounts.products.find(
                  (p) => product.product === p.product && promo.id === p.promo
                );
                if (product_promo) {
                  product_promo.quantity =
                    product.quantity * new_quantity -
                    (product.quantity * (new_quantity - 1) -
                      product_promo.quantity);

                  if (promo.auto_add_free_products) {
                    let freeQuantityLeft = product.quantity;

                    if (freeQuantityLeft > 0) {
                      async_add_promo_item(
                        storeCategories || [],
                        product,
                        freeQuantityLeft,
                        promo.id,
                        asyncDispatch,
                        smart_promos
                      );
                    }
                  }
                }
              }
            });
          } else if (discount.type === "category" && !existing_promo) {
            if (!NewDiscounts.category.length) {
              NewDiscounts.category.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.category.length; i++) {
                if (discount.value >= NewDiscounts.category[i].value) {
                  NewDiscounts.category.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.category.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "products_percent" && !existing_promo) {
            if (!NewDiscounts.products_percent.length) {
              NewDiscounts.products_percent.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.products_percent.length; i++) {
                if (discount.value >= NewDiscounts.products_percent[i].value) {
                  NewDiscounts.products_percent.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.products_percent.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "modifier" && !existing_promo) {
            if (!NewDiscounts.modifier.length) {
              NewDiscounts.modifier.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.modifier.length; i++) {
                if (discount.value >= NewDiscounts.modifier[i].value) {
                  NewDiscounts.modifier.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.modifier.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "category_free" && discount.categories) {
            if (!existing_promo) {
              NewDiscounts.category_free.push({
                categories: discount.categories,
                original_quantity: discount.value,
                quantity: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
                promo: promo.id,
                id: discount.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });

              if (promo.auto_add_free_products) {
                const hasProductRelatedConditions = smart_promos.some(
                  (sp) =>
                    NewSmart_promos.map((nsp) => nsp.id).includes(sp.id) &&
                    sp.conditions.some((c) =>
                      [
                        "value",
                        "number",
                        "products",
                        "category_value",
                        "category_number",
                      ].includes(c.type)
                    )
                );
                if (!hasProductRelatedConditions) {
                  switchToFreeProduct(
                    NewCart,
                    discount.categories,
                    discount.value,
                    promo,
                    discount.id,
                    asyncDispatch,
                    "category_free"
                  );
                }
              }
            } else {
              let category_promo = NewDiscounts.category_free.find(
                (p) => promo.id === p.promo && p.id === discount.id
              );
              if (category_promo) {
                category_promo.quantity =
                  discount.value * new_quantity -
                  (discount.value * (new_quantity - 1) -
                    category_promo.quantity);
              }
            }
          } else if (discount.type === "cashback_fixed" && !existing_promo) {
            if (!NewDiscounts.cashback_fixed.length) {
              NewDiscounts.cashback_fixed.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.cashback_fixed.length; i++) {
                if (discount.value >= NewDiscounts.cashback_fixed[i].value) {
                  NewDiscounts.cashback_fixed.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.cashback_fixed.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (discount.type === "cashback_percent" && !existing_promo) {
            if (!NewDiscounts.cashback_percent.length) {
              NewDiscounts.cashback_percent.push({
                ...discount,
                promo: promo.id,
                discount_amount: !promo.repeatable
                  ? discount.value
                  : discount.value * new_quantity,
              });
            } else {
              let added = false;
              for (let i = 0; i < NewDiscounts.cashback_percent.length; i++) {
                if (discount.value >= NewDiscounts.cashback_percent[i].value) {
                  NewDiscounts.cashback_percent.splice(i, 0, {
                    ...discount,
                    promo: promo.id,
                    discount_amount: !promo.repeatable
                      ? discount.value
                      : discount.value * new_quantity,
                  });
                  added = true;
                  break;
                }
              }
              if (!added) {
                NewDiscounts.cashback_percent.push({
                  ...discount,
                  promo: promo.id,
                  discount_amount: !promo.repeatable
                    ? discount.value
                    : discount.value * new_quantity,
                });
              }
            }
          } else if (existing_promo && discount.type !== "delivery") {
            const combinedDiscounts = { delivery_percent: "delivery" };
            const existingDiscount = NewDiscounts[
              combinedDiscounts[discount.type] || discount.type
            ].find((d) => d.id === discount.id);

            if (existingDiscount) {
              existingDiscount.discount_amount =
                existing_promo.quantity * existingDiscount.value;
            }
          }
        });
      }
    }
  });
  return { NewSmart_promos, NewDiscounts, NewPromoItems };
}

function ShouldRemovePromo(
  smart_promos,
  NewSmart_promos,
  NewDiscounts,
  newPrice,
  NewNumber_of_items,
  NewCart,
  NewPromoItems,
  newCharge_delivery,
  newDelivered_items,
  newPreparation_time,
  newAppliedCoupon,
  asyncDispatch,
  customerAddress,
  branchDetails,
  authUser,
  storeCategories,
  storeSettings,
  deliveryTime,
  customerBin
) {
  let promo;
  let remove_promo = false;
  let multiplier = 1;
  let new_quantity = Infinity;
  const serviceTypes = { 0: "delivery", 1: "pickup" };
  const deliveryArrivalTime = { asap: "asap", scheduled: "scheduled" };

  for (let i = 0; i < NewSmart_promos.length; i++) {
    promo = smart_promos.find((p) => p.id === NewSmart_promos[i].id);

    if (
      promo &&
      (promo.quantity_per_user < 1 ||
        (authUser && promo.quantity_per_user > promo.user_quantity_used))
    ) {
      if (NewSmart_promos[i].repeatable) new_quantity = Infinity;
      else new_quantity = 0;
      multiplier = NewSmart_promos[i].quantity;
      let totalPrice = newPrice;
      let totalItems = NewNumber_of_items;
      if (
        promo.excluded_products.length ||
        promo.excluded_categories.length ||
        promo.excluded_modifiers.length
      ) {
        [totalPrice, totalItems] = getTotalExcludeProducts(
          NewCart,
          promo.excluded_products,
          promo.excluded_categories,
          promo.excluded_modifiers
        );
      }
      for (let j = 0; j < promo.conditions.length; j++) {
        if (promo.remaining < 0) {
          remove_promo = true;
          new_quantity = NewSmart_promos[i].quantity + promo.remaining;
          break;
        }

        if (
          promo.conditions[j].type === "value" &&
          totalPrice < promo.conditions[j].value * multiplier
        ) {
          if (NewSmart_promos[i].repeatable) {
            new_quantity = Math.min(
              new_quantity,
              parseInt(totalPrice / promo.conditions[j].value)
            );
          }
          remove_promo = true;

          if (!NewSmart_promos[i].repeatable || new_quantity === 0) break;
        } else if (
          promo.conditions[j].type === "number" &&
          totalItems < promo.conditions[j].value * multiplier
        ) {
          if (NewSmart_promos[i].repeatable) {
            new_quantity = Math.min(
              new_quantity,
              parseInt(totalItems / promo.conditions[j].value)
            );
          }

          remove_promo = true;
          if (!NewSmart_promos[i].repeatable || new_quantity === 0) break;
        } else if (promo.conditions[j].type === "products") {
          let [product_condition, tmp_quantity] = CheckPromoProducts(
            promo.conditions[j].products,
            NewCart,
            multiplier,
            promo.conditions[j].value
          );
          if (!product_condition) {
            if (NewSmart_promos[i].repeatable) {
              new_quantity = Math.min(new_quantity, tmp_quantity);
            }
            remove_promo = true;
            if (!NewSmart_promos[i].repeatable || new_quantity === 0) break;
          }
        } else if (
          promo.conditions[j].type === "coupon" &&
          (!newAppliedCoupon ||
            (newAppliedCoupon && newAppliedCoupon.id != promo.id))
        ) {
          remove_promo = true;
          break;
        } else if (promo.conditions[j].type === "category_value") {
          let [categoryTotalPrice, _] = getCategoryTotal(
            NewCart,
            promo.conditions[j].categories?.ids,
            promo.excluded_products,
            promo.excluded_categories,
            promo.excluded_modifiers,
            storeCategories
          );
          if (categoryTotalPrice < promo.conditions[j].value * multiplier) {
            remove_promo = true;
            if (NewSmart_promos[i].repeatable) {
              new_quantity = Math.min(
                new_quantity,
                parseInt(categoryTotalPrice / promo.conditions[j].value)
              );
            }
          }
        } else if (promo.conditions[j].type === "category_number") {
          let [_, cateogryTotalItems] = getCategoryTotal(
            NewCart,
            promo.conditions[j].categories?.ids,
            promo.excluded_products,
            promo.excluded_categories,
            promo.excluded_modifiers,
            storeCategories
          );
          if (cateogryTotalItems < promo.conditions[j].value * multiplier) {
            remove_promo = true;
            if (NewSmart_promos[i].repeatable) {
              new_quantity = Math.min(
                new_quantity,
                parseInt(cateogryTotalItems / promo.conditions[j].value)
              );
            }
          }
        } else if (
          promo.conditions[j].type === "service_type" &&
          (!customerAddress ||
            serviceTypes[customerAddress.selectedDeliveryType] !==
              promo.conditions[j].value)
        ) {
          remove_promo = true;
          break;
        } else if (
          promo.conditions[j].type === "delivery_arrival_time" &&
          (!deliveryTime?.type ||
            deliveryArrivalTime[deliveryTime.type] !==
              promo.conditions[j].value)
        ) {
          remove_promo = true;
          break;
        } else if (promo.conditions[j].type === "delivery_area") {
          let area_id;
          if (customerAddress?.selectedDeliveryType === 0) {
            if (branchDetails?.branch) {
              area_id = branchDetails.bdc;
            } else {
              area_id = customerAddress.area;
            }
          }

          if (!area_id || !promo.conditions[j].value?.ids.includes(area_id)) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "branch") {
          let branch_id;
          if (branchDetails?.branch) {
            branch_id = branchDetails.branch;
          } else if (customerAddress?.selectedDeliveryType === 1) {
            branch_id = customerAddress.pickupArea;
          }

          if (
            !branch_id ||
            !promo.conditions[j].value?.ids.includes(branch_id)
          ) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "country") {
          let country_id = customerAddress?.country;

          if (
            !country_id ||
            !promo.conditions[j].value?.ids.includes(country_id)
          ) {
            remove_promo = true;
            break;
          }
        } else if (
          promo.conditions[j].type === "points" &&
          (authUser?.points < promo.conditions[j].value ||
            !newAppliedCoupon ||
            newAppliedCoupon.id !== promo.id)
        ) {
          remove_promo = true;
          break;
        } else if (promo.conditions[j].type === "orders") {
          if (
            !authUser ||
            authUser.orders_count !== promo.conditions[j].value
          ) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "orders_more") {
          if (!authUser || authUser.orders_count <= promo.conditions[j].value) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "orders_less") {
          if (!authUser || authUser.orders_count >= promo.conditions[j].value) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "first_time") {
          if (
            !authUser ||
            authUser.orders_count > 0 ||
            moment(authUser.created).isBefore(moment(promo.created))
          ) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "card_scheme") {
          if (
            promo.conditions[j].value?.toLowerCase() !==
            customerBin?.card_scheme?.toLowerCase()
          ) {
            remove_promo = true;
            break;
          }
        } else if (promo.conditions[j].type === "card_bank") {
          if (
            !(tapBanks[promo.conditions[j].value] || []).includes(
              customerBin?.bank?.toLowerCase()
            )
          ) {
            remove_promo = true;
            break;
          }
        }
        continue;
      }
    } else {
      remove_promo = true;
      new_quantity = 0;
      promo = { id: NewSmart_promos[i].id };
    }

    if (
      !remove_promo &&
      (promo.version !== NewSmart_promos[i].version ||
        (!authUser &&
          promo.discounts.some((d) =>
            ["cashback_fixed", "cashback_percent"].includes(d.type)
          )))
    ) {
      remove_promo = true;
      new_quantity = 0;
    }
    if (new_quantity === Infinity) {
      new_quantity = 0;
    }
    if (
      storeSettings?.allow_one_promo &&
      (NewSmart_promos.length > 1 || newAppliedCoupon) &&
      ((newAppliedCoupon &&
        (!newAppliedCoupon.isSmartPromo || newAppliedCoupon?.id != promo.id)) ||
        NewSmart_promos.some((p) => p.id > promo.id))
    ) {
      remove_promo = true;
      new_quantity = 0;
    }

    if (remove_promo) {
      const delta_quantity = NewSmart_promos[i].quantity - new_quantity;

      NewSmart_promos[i].quantity = NewSmart_promos[i].repeatable
        ? new_quantity
        : 0;

      const promo_should_be_removed = NewSmart_promos[i].quantity <= 0;

      // promo qunatity
      promo.remaining += delta_quantity;

      if (promo_should_be_removed) {
        NewSmart_promos.splice(i, 1);
        i--;
        if (NewDiscounts.delivery.length) {
          NewDiscounts.delivery = NewDiscounts.delivery.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.fixed.length) {
          NewDiscounts.fixed = NewDiscounts.fixed.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.percent.length) {
          NewDiscounts.percent = NewDiscounts.percent.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.category.length) {
          NewDiscounts.category = NewDiscounts.category.filter(
            (p) => p.promo !== promo.id
          );
        }

        if (NewDiscounts.products_percent.length) {
          NewDiscounts.products_percent = NewDiscounts.products_percent.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.modifier.length) {
          NewDiscounts.modifier = NewDiscounts.modifier.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.cashback_fixed.length) {
          NewDiscounts.cashback_fixed = NewDiscounts.cashback_fixed.filter(
            (p) => p.promo !== promo.id
          );
        }
        if (NewDiscounts.cashback_percent.length) {
          NewDiscounts.cashback_percent = NewDiscounts.cashback_percent.filter(
            (p) => p.promo !== promo.id
          );
        }
      } else {
        let cat = Object.keys(NewDiscounts).filter(
          (d) => !["products", "category_free"].includes(d)
        );

        for (let category of cat) {
          if (NewDiscounts[category].length) {
            NewDiscounts[category] = NewDiscounts[category].map((discount) => {
              if (
                discount.promo === promo.id &&
                !(discount.type == "delivery" && discount.value == 100)
              ) {
                discount.discount_amount =
                  NewSmart_promos[i].quantity * discount.value;
              }
              return discount;
            });
          }
        }
      }
      if (NewDiscounts.products.length) {
        if (promo_should_be_removed) {
          NewDiscounts.products = NewDiscounts.products.filter(
            (p) => p.promo !== promo.id
          );
          NewPromoItems = NewPromoItems.filter((p) => {
            if (p.promo === promo.id) {
              asyncDispatch({
                type: REDUCE_QUANTITY,
                payload: { product: p, change: -p.quantity },
              });
              if (p.is_delivered) {
                newDelivered_items -= 1;
              }
              if (p.charge_delivery) {
                newCharge_delivery -= 1;
              }

              return false;
            }
            return true;
          });
        } else {
          NewDiscounts.products.forEach((p) => {
            if (p.promo === promo.id) {
              p.quantity -= delta_quantity * p.original_quantity;
              if (p.quantity < 0) {
                for (let i = 0; i < NewPromoItems.length; i++) {
                  if (
                    NewPromoItems[i].id === p.product &&
                    NewPromoItems[i].promo === p.promo
                  ) {
                    if (NewPromoItems[i].quantity > Math.abs(p.quantity)) {
                      NewPromoItems[i].quantity += p.quantity;
                      asyncDispatch({
                        type: REDUCE_QUANTITY,
                        payload: {
                          product: NewPromoItems[i],
                          change: p.quantity,
                        },
                      });
                      p.quantity = 0;

                      break;
                    } else {
                      p.quantity += NewPromoItems[i].quantity;

                      if (NewPromoItems[i].is_delivered) {
                        newDelivered_items -= 1;
                      }
                      if (NewPromoItems[i].charge_delivery) {
                        newCharge_delivery -= 1;
                      }

                      asyncDispatch({
                        type: REDUCE_QUANTITY,
                        payload: {
                          product: NewPromoItems[i],
                          change: -NewPromoItems[i].quantity,
                        },
                      });
                      NewPromoItems.splice(i, 1);
                      if (p.quantity >= 0) {
                        break;
                      }
                      i--;
                      continue;
                    }
                  }
                }
              }
            }
          });
        }
      }

      if (NewDiscounts.category_free.length) {
        if (promo_should_be_removed) {
          NewDiscounts.category_free = NewDiscounts.category_free.filter(
            (p) => p.promo !== promo.id
          );
          NewPromoItems = NewPromoItems.filter((p) => {
            if (p.promo === promo.id) {
              asyncDispatch({
                type: REDUCE_QUANTITY,
                payload: { product: p, change: -p.quantity },
              });
              if (p.is_delivered) {
                newDelivered_items -= 1;
              }
              if (p.charge_delivery) {
                newCharge_delivery -= 1;
              }

              return false;
            }
            return true;
          });
        } else {
          NewDiscounts.category_free.forEach((p) => {
            if (p.promo === promo.id) {
              p.quantity -= delta_quantity * p.original_quantity;

              if (p.quantity < 0) {
                for (let i = 0; i < NewPromoItems.length; i++) {
                  if (p.categories.includes(NewPromoItems[i].category_id)) {
                    if (NewPromoItems[i].quantity > Math.abs(p.quantity)) {
                      NewPromoItems[i].quantity += p.quantity;
                      asyncDispatch({
                        type: REDUCE_QUANTITY,
                        payload: {
                          product: NewPromoItems[i],
                          change: p.quantity,
                        },
                      });
                      p.quantity = 0;

                      break;
                    } else {
                      p.quantity += NewPromoItems[i].quantity;

                      if (NewPromoItems[i].is_delivered) {
                        newDelivered_items -= 1;
                      }
                      if (NewPromoItems[i].charge_delivery) {
                        newCharge_delivery -= 1;
                      }

                      asyncDispatch({
                        type: REDUCE_QUANTITY,
                        payload: {
                          product: NewPromoItems[i],
                          change: -NewPromoItems[i].quantity,
                        },
                      });
                      NewPromoItems.splice(i, 1);
                      if (p.quantity >= 0) {
                        break;
                      }
                      i--;
                      continue;
                    }
                  }
                }
              }
            }
          });
        }
      }

      remove_promo = false;
    }
  }

  return {
    NewSmart_promos,
    NewDiscounts,
    NewPromoItems,
    newCharge_delivery,
    newDelivered_items,
    newPreparation_time,
  };
}

const tapBanks = {
  "Ahli United Bank – Kuwait": ["ahli united bank"],
  "Al Ahli Bank of Kuwait (ABK)": [
    "al ahli bank of kuwait (ksc)",
    "alahli bank of kuwait (k.s.c.)",
  ],
  "Boubyan Bank": ["boubyan bank", "boubyan bank k.s.c."],
  "Burgan Bank": ["burgan bank (s.a.k.)", "burgan bank, s.a.k."],
  "Commercial Bank of Kuwait (CBK)": [
    "commercial bank of kuwait s.a.k., the",
    "commercial bank of kuwait, s.a.k.",
  ],
  "Gulf Bank (GBK)": ["gulf bank k.s.c., the", "gulf bank k.s.c."],
  "National Bank of Kuwait (NBK)": [
    "national bank of kuwait",
    "national bank of kuwait s.a.k.",
    "national bank of kuwait (s.a.k.)",
  ],
  "Kuwait Finance House (KFH)": [
    "kuwait finance house k.s.c.",
    "kuwait finance house",
  ],
  "Kuwait International Bank (KIB)": ["kuwait international bank"],
  "Warba Bank": ["warba bank k.s.c", "warba bank k.s.c."],
};

export default (
  state = initialState,
  {
    type,
    payload,
    smart_promos,
    promo_added_function,
    asyncDispatch,
    InCheckCart,
    customerAddress,
    branchDetails,
    updatePromotionQuantity = true,
    nonMingledParentCategory,
    parentCategories,
    authUser,
    storeCategories,
    storeSettings,
    deliveryTime,
    customerBin,
  }
) => {
  try {
    let newCart = [...state.cart];
    let ProductIndex = 0;
    let newPrice = state.price;
    let quantity_difference = 0;
    let price_difference = 0;
    let newCharge_delivery = state.charged_items;
    let newDelivered_items = state.delivered_items;
    let newPickupOnlyItems = state.pickup_only_items;
    let newDeliveryOnlyItems = state.delivery_only_items;
    let newCashOnlyItems = state.cash_only_items;
    let newCreditOnlyItems = state.credit_only_items;
    let newPreparation_time = state.preparation_time;
    let NewSmart_promos = [...state.smart_promos];
    let NewNumber_of_items = state.number_of_items;
    let NewDiscounts = { ...state.discounts };
    let NewPromoItems = [...state.promo_items];
    let newMingled_item = state.mingled_item;
    let newNonMingledCategories = state.non_mingled_category;
    let newAppliedCoupon = state.promos;

    let newCategories_min_order = { ...state.categories_min_order };
    let promo_discount;
    let removedProduct;
    let cart_product;
    let newPreorderedItems = state.preordered_items;
    let newPreorderingMaxLeadtime = state.preordering_max_leadtime;

    let productMinCategories;

    switch (type) {
      case CLEAR_CART:
        return {
          cart: [],
          price: 0,
          delivered_items: 0,
          charged_items: 0,
          pickup_only_items: 0,
          delivery_only_items: 0,
          credit_only_items: 0,
          cash_only_items: 0,
          promos: null,
          smart_promos: [],
          discounts: {
            percent: [],
            fixed: [],
            delivery: [],
            products: [],
            category: [],
            products_percent: [],
            modifier: [],
            category_free: [],
            cashback_fixed: [],
            cashback_percent: [],
          },
          promo_items: [],
          preparation_time: 0,
          number_of_items: 0,
          mingled_item: false,
          categories_min_order: {},
          preordered_items: 0,
          preordering_max_leadtime: 0,
          non_mingled_category: null,
          payment_method: state.payment_method,
        };
      case ADD_To_CART:
        newPrice = preciseNumber(
          state.price + payload.total_price * payload.quantity
        );

        ProductIndex = newCart.findIndex(
          (product) =>
            product.id === payload.id && CheckDuplicate2(product, payload)
        );
        let isDuplicateProduct = false;
        if (ProductIndex === -1) {
          newPrice = preciseNumber(
            newPrice + payload.quantityExcludedOptionsTotal
          );
          ProductIndex = newCart.push(payload) - 1;

          if (payload.is_delivered) {
            newDelivered_items += 1;
          }
          if (payload.charge_delivery) {
            newCharge_delivery += 1;
          }
          if (payload.pickup_only) {
            newPickupOnlyItems += 1;
            newDeliveryOnlyItems = 0;
          }
          if (payload.delivery_only) {
            newDeliveryOnlyItems += 1;
            newPickupOnlyItems = 0;
          }
          if (payload.credit_only) {
            newCreditOnlyItems += 1;
            newCashOnlyItems = 0;
          }
          if (payload.cash_only) {
            newCashOnlyItems += 1;
            newCreditOnlyItems = 0;
          }
          if (payload.is_preordered) {
            newPreorderedItems += 1;
            if (payload.preordering_leadtime > newPreorderingMaxLeadtime) {
              newPreorderingMaxLeadtime = payload.preordering_leadtime;
            }
          }
        } else {
          isDuplicateProduct = true;
          newCart[ProductIndex].quantity += payload.quantity;
        }
        NewNumber_of_items = preciseNumber(
          NewNumber_of_items + payload.quantity
        );
        if (!state.mingled_item && payload.no_mingling) {
          newMingled_item = true;
        }

        if (
          (nonMingledParentCategory || payload.category_no_mingling) &&
          !state.mingledCategory
        ) {
          newNonMingledCategories =
            nonMingledParentCategory || payload.category_id;
        }
        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        //min
        productMinCategories = [payload.category_id];
        if (parentCategories) {
          productMinCategories = productMinCategories.concat(parentCategories);
        }
        productMinCategories.forEach((cat) => {
          newCategories_min_order[cat] = preciseNumber(
            (newCategories_min_order[cat] || 0) +
              payload.total_price * payload.quantity
          );
          if (!isDuplicateProduct) {
            newCategories_min_order[cat] = preciseNumber(
              newCategories_min_order[cat] +
                payload.quantityExcludedOptionsTotal
            );
          }
        });

        return {
          ...state,
          cart: newCart,
          price: newPrice,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          number_of_items: NewNumber_of_items,
          promo_items: NewPromoItems,
          mingled_item: newMingled_item,
          categories_min_order: newCategories_min_order,
          pickup_only_items: Math.max(0, newPickupOnlyItems),
          delivery_only_items: Math.max(0, newDeliveryOnlyItems),
          cash_only_items: Math.max(0, newCashOnlyItems),
          credit_only_items: Math.max(0, newCreditOnlyItems),
          preordered_items: newPreorderedItems,
          preordering_max_leadtime: newPreorderingMaxLeadtime,
          non_mingled_category: newNonMingledCategories,
        };
      case EDIT_CART:
        quantity_difference =
          newCart[payload.product].quantity - payload.quantity;
        price_difference = newCart[payload.product].price - payload.price;
        newCart[payload.product].quantity = payload.quantity;
        newCart[payload.product].price = payload.price;
        newCart[payload.product].total_price -= price_difference;

        newPrice = preciseNumber(
          state.price -
            price_difference * newCart[payload.product].quantity -
            newCart[payload.product].total_price * quantity_difference
        );

        if (
          newCart[payload.product].charge_delivery !== payload.charge_delivery
        ) {
          newCharge_delivery +=
            payload.charge_delivery - newCart[payload.product].charge_delivery;
        }

        if (newCart[payload.product].is_delivered !== payload.is_delivered) {
          newDelivered_items +=
            payload.is_delivered - newCart[payload.product].is_delivered;
        }
        newCart[payload.product].is_delivered = payload.is_delivered;
        newCart[payload.product].charge_delivery = payload.charge_delivery;
        newCart[payload.product].preparation_time = payload.preparation_time;
        newCart[payload.product].preordering_leadtime =
          payload.preordering_leadtime;

        NewNumber_of_items = preciseNumber(
          NewNumber_of_items - quantity_difference
        );
        if (NewNumber_of_items < 0) NewNumber_of_items = 0;

        if (NewSmart_promos.length && smart_promos && smart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        //Max Inventory Slot

        return {
          ...state,
          cart: newCart,
          price: newPrice,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          number_of_items: NewNumber_of_items,
          promo_items: NewPromoItems,
          preparation_time: newPreparation_time,
        };

      case REMOVE_FROM_CART:
        removedProduct = newCart.splice(payload, 1)[0];

        newPrice = preciseNumber(
          preciseNumber(
            state.price - removedProduct.total_price * removedProduct.quantity
          ) - removedProduct.quantityExcludedOptionsTotal
        );
        if (newPrice < 0) newPrice = 0;
        if (removedProduct.is_delivered) newDelivered_items -= 1;
        if (removedProduct.charge_delivery) newCharge_delivery -= 1;
        if (removedProduct.pickup_only) newPickupOnlyItems -= 1;
        if (removedProduct.delivery_only) newDeliveryOnlyItems -= 1;
        if (removedProduct.is_preordered) newPreorderedItems -= 1;
        if (removedProduct.cash_only) newCashOnlyItems -= 1;
        if (removedProduct.credit_only) newCreditOnlyItems -= 1;

        if (removedProduct.preordering_leadtime === newPreorderingMaxLeadtime) {
          let all_items = newCart.concat(state.promo_items);
          newPreorderingMaxLeadtime = calculate_preordering_leadtime(all_items);
        }

        NewNumber_of_items = preciseNumber(
          NewNumber_of_items - removedProduct.quantity
        );
        if (NewNumber_of_items < 0) NewNumber_of_items = 0;
        if (NewSmart_promos.length && smart_promos && smart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (!newCart.length) {
          newMingled_item = false;
          newNonMingledCategories = null;
        }

        // Min
        productMinCategories = [removedProduct.category_id];
        if (parentCategories) {
          productMinCategories = productMinCategories.concat(parentCategories);
        }
        productMinCategories.forEach((cat) => {
          newCategories_min_order[cat] = preciseNumber(
            preciseNumber(
              (newCategories_min_order[cat] || 0) -
                removedProduct.total_price * removedProduct.quantity
            ) - removedProduct.quantityExcludedOptionsTotal
          );
          if (newCategories_min_order[cat] <= 0) {
            delete newCategories_min_order[cat];
          }
        });

        return {
          ...state,
          cart: [...newCart],
          price: newPrice,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          number_of_items: NewNumber_of_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          mingled_item: newMingled_item,
          categories_min_order: newCategories_min_order,
          pickup_only_items: Math.max(0, newPickupOnlyItems),
          delivery_only_items: Math.max(0, newDeliveryOnlyItems),
          cash_only_items: Math.max(0, newCashOnlyItems),
          credit_only_items: Math.max(0, newCreditOnlyItems),
          preordered_items: newPreorderedItems,
          preordering_max_leadtime: newPreorderingMaxLeadtime,
          non_mingled_category: newNonMingledCategories,
        };

      case EDIT_OPTION:
        if (payload.is_promo_item) {
          cart_product = NewPromoItems[payload.product];
        } else {
          cart_product = newCart[payload.product];
        }

        let optionGroup = cart_product.options[payload.group_id];
        let option = optionGroup.selectedOptions[payload.choice];

        price_difference = option.price - payload.price;
        if (optionGroup.quantityExclusive) {
          cart_product.quantityExcludedOptionsTotal = preciseNumber(
            cart_product.quantityExcludedOptionsTotal -
              price_difference * option.quantity
          );
          newPrice = preciseNumber(
            state.price - price_difference * option.quantity
          );
        } else {
          cart_product.total_price = preciseNumber(
            cart_product.total_price - price_difference * option.quantity
          );
          newPrice = preciseNumber(
            state.price -
              price_difference * option.quantity * cart_product.quantity
          );
        }

        option.price = payload.price;

        return {
          ...state,
          cart: newCart,
          price: newPrice,
          promo_items: NewPromoItems,
        };
      case EDIT_BOOKING:
        if (payload.is_promo_item) {
          cart_product = NewPromoItems[payload.product];
        } else {
          cart_product = newCart[payload.product];
        }
        quantity_difference = cart_product.quantity - payload.quantity;
        if (!payload.is_promo_item) {
          NewNumber_of_items = preciseNumber(
            NewNumber_of_items - quantity_difference
          );
        }
        cart_product.quantity = payload.quantity;

        newPrice = preciseNumber(
          state.price - cart_product.total_price * quantity_difference
        );
        if (cart_product.promo) {
          promo_discount = NewDiscounts.products.find(
            (p) =>
              p.id === cart_product.discount &&
              p.promo === cart_product.promo &&
              ((!p.has_variants && p.product === cart_product.id) ||
                (p.has_variants && p.product === cart_product.parent))
          );
          promo_discount.quantity += quantity_difference;
        }

        return {
          ...state,
          cart: newCart,
          price: newPrice,
          promo_items: NewPromoItems,
          discounts: NewDiscounts,
          number_of_items: NewNumber_of_items,
        };
      case EDIT_QUANTITY:
        let product = newCart[payload.product];
        newPrice = preciseNumber(
          state.price -
            product.total_price * (product.quantity - payload.quantity)
        );
        const difference_quantity = payload.quantity - product.quantity;
        product.quantity = payload.quantity;
        NewNumber_of_items = preciseNumber(
          NewNumber_of_items + difference_quantity
        );

        if (NewNumber_of_items < 0) NewNumber_of_items = 0;

        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (NewSmart_promos.length && smart_promos && smart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (
          smart_promos &&
          smart_promos.length &&
          storeSettings?.allow_one_promo
        ) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        //min

        productMinCategories = [product.category_id];
        if (parentCategories) {
          productMinCategories = productMinCategories.concat(parentCategories);
        }
        productMinCategories.forEach((cat) => {
          newCategories_min_order[cat] = preciseNumber(
            (newCategories_min_order[cat] || 0) +
              product.total_price * difference_quantity
          );
        });

        return {
          ...state,
          cart: [...newCart],
          price: newPrice,
          number_of_items: NewNumber_of_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          categories_min_order: newCategories_min_order,
        };

      case APPLY_PROMO:
        newAppliedCoupon = null;
        if (payload) {
          newAppliedCoupon = payload;
        }

        if (
          newAppliedCoupon &&
          newAppliedCoupon.promo &&
          newAppliedCoupon.is_private &&
          !smart_promos.find((p) => p.id === newAppliedCoupon.promo.id)
        ) {
          smart_promos.push(newAppliedCoupon.promo);
          asyncDispatch({
            type: SET_SMART_PROMOS,
            payload: smart_promos,
          });
        }

        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        if (smart_promos && smart_promos.length && NewSmart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        if (
          smart_promos &&
          smart_promos.length &&
          storeSettings?.allow_one_promo
        ) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        return {
          ...state,
          promos: newAppliedCoupon,
          cart: [...newCart],
          price: newPrice,
          number_of_items: NewNumber_of_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
        };

      case SET_PREP_AND_LEAD_TIME:
        let all_items = state.cart.concat(state.promo_items);
        newPreorderingMaxLeadtime = calculate_preordering_leadtime(all_items);

        return {
          ...state,
          preparation_time: newPreparation_time,
          preordering_max_leadtime: newPreorderingMaxLeadtime,
        };

      case ADD_PROMO_ITEM:
        ProductIndex = NewPromoItems.findIndex(
          (product) =>
            product.id === payload.id && CheckDuplicate2(product, payload, true)
        );
        let isNewItem = false;
        if (ProductIndex === -1) {
          isNewItem = true;
          ProductIndex = NewPromoItems.push(payload) - 1;

          if (payload.is_delivered) {
            newDelivered_items += 1;
          }
          if (payload.charge_delivery) {
            newCharge_delivery += 1;
          }
          if (payload.pickup_only) {
            newPickupOnlyItems += 1;
          }

          if (payload.delivery_only) {
            newDeliveryOnlyItems += 1;
          }
          if (payload.cash_only) {
            newCashOnlyItems += 1;
          }
          if (payload.credit_only) {
            newCreditOnlyItems += 1;
          }
        } else {
          NewPromoItems[ProductIndex].quantity += payload.quantity;
        }

        let promo;
        if (payload.discountType === "category_free") {
          promo = NewDiscounts.category_free.find(
            (p) => p.id === payload.discount && p.promo === payload.promo
          );
        } else {
          promo = NewDiscounts.products.find(
            (p) =>
              p.id === payload.discount &&
              p.promo === payload.promo &&
              ((!p.has_variants && p.product === payload.id) ||
                (p.has_variants && p.product === payload.parent))
          );
        }

        if (promo) {
          if (isNewItem) {
            const excluded_modifiers =
              smart_promos.find((p) => p.id === promo.promo)
                ?.excluded_modifiers || [];
            if (excluded_modifiers.length) {
              const { promoTotalPrice, promoQuantityExclusivePrice } =
                getPromoItemPriceExcludingModifiers(
                  NewPromoItems[ProductIndex].options,
                  excluded_modifiers,
                  1
                );
              if (promoTotalPrice > 0 || promoQuantityExclusivePrice > 0) {
                NewPromoItems[ProductIndex].total_price = promoTotalPrice;
                NewPromoItems[ProductIndex].quantityExcludedOptionsTotal =
                  promoQuantityExclusivePrice;
                newPrice = preciseNumber(
                  newPrice +
                    (NewPromoItems[ProductIndex].total_price *
                      NewPromoItems[ProductIndex].quantity +
                      NewPromoItems[ProductIndex].quantityExcludedOptionsTotal)
                );
              }
            }
          } else if (NewPromoItems[ProductIndex].total_price > 0) {
            newPrice = preciseNumber(
              newPrice +
                NewPromoItems[ProductIndex].total_price * payload.quantity
            );
          }
          promo.quantity -= payload.quantity;
        }

        if (!state.mingled_item && payload.no_mingling) {
          newMingled_item = true;
        }
        return {
          ...state,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          mingled_item: newMingled_item,
          pickup_only_items: Math.max(0, newPickupOnlyItems),
          delivery_only_items: Math.max(0, newDeliveryOnlyItems),
          cash_only_items: Math.max(0, newCashOnlyItems),
          credit_only_items: Math.max(0, newCreditOnlyItems),
          price: newPrice,
        };
      case UPDATE_PROMOTION:
        let store_promo;
        if (updatePromotionQuantity) {
          NewSmart_promos.forEach((cart_promo) => {
            store_promo = smart_promos.find((p) => p.id === cart_promo.id);
            if (store_promo) store_promo.remaining -= cart_promo.quantity;
          });
        }
        if (NewSmart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (
          (NewSmart_promos.length > 1 || newAppliedCoupon) &&
          storeSettings.allow_one_promo
        ) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }
        if (NewDiscounts.fixed.length) {
          NewDiscounts.fixed.forEach((fixedDiscount) => {
            const smartPromo = smart_promos.find(
              (p) => p.id === fixedDiscount.promo
            );

            if (smartPromo) {
              const discount = smartPromo.discounts.find(
                (d) => d.id === fixedDiscount.id
              );
              if (discount) {
                fixedDiscount.value = discount.value;
              }
            }
          });
        }

        return {
          ...state,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
        };
      case EDIT_CART_PROMO_ITEM:
        const promo_item = NewPromoItems[payload.product];
        quantity_difference = promo_item.quantity - payload.quantity;
        price_difference = promo_item.price - payload.price;
        promo_item.quantity = payload.quantity;
        promo_item.price = payload.price;
        promo_item.total_price -= price_difference;
        newPrice = preciseNumber(
          state.price -
            price_difference * promo_item.quantity -
            promo_item.total_price * quantity_difference
        );

        if (promo_item.charge_delivery !== payload.charge_delivery) {
          newCharge_delivery +=
            payload.charge_delivery - promo_item.charge_delivery;
        }

        if (promo_item.is_delivered !== payload.is_delivered) {
          newDelivered_items += payload.is_delivered - promo_item.is_delivered;
        }
        promo_item.is_delivered = payload.is_delivered;
        promo_item.charge_delivery = payload.charge_delivery;
        promo_item.preparation_time = payload.preparation_time;

        promo_discount = NewDiscounts.products.find(
          (p) =>
            p.id === promo_item.discount &&
            p.promo === promo_item.promo &&
            ((!p.has_variants && p.product === promo_item.id) ||
              (p.has_variants && p.product === promo_item.parent))
        );

        if (promo_discount) promo_discount.quantity += quantity_difference;

        return {
          ...state,
          cart: newCart,
          price: newPrice,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          preparation_time: newPreparation_time,
        };
      case REMOVE_FROM_CART_PROMO_ITEM:
        removedProduct = NewPromoItems.splice(payload, 1)[0];
        newPrice = preciseNumber(
          preciseNumber(
            state.price - removedProduct.total_price * removedProduct.quantity
          ) - removedProduct.quantityExcludedOptionsTotal
        );

        if (newPrice < 0) newPrice = 0;
        if (removedProduct.is_delivered) newDelivered_items -= 1;
        if (removedProduct.charge_delivery) newCharge_delivery -= 1;
        if (removedProduct.pickup_only) newPickupOnlyItems -= 1;
        if (removedProduct.delivery_only) newDeliveryOnlyItems -= 1;
        if (removedProduct.cash_only) newCashOnlyItems -= 1;
        if (removedProduct.credit_only) newCreditOnlyItems -= 1;

        if (removedProduct?.discountType === "category_free") {
          promo_discount = NewDiscounts.category_free.find(
            (p) =>
              p.id === removedProduct.discount &&
              p.promo === removedProduct.promo
          );
        } else {
          promo_discount = NewDiscounts.products.find(
            (p) =>
              p.id === removedProduct.discount &&
              p.promo === removedProduct.promo &&
              ((!p.has_variants && p.product === removedProduct.id) ||
                (p.has_variants && p.product === removedProduct.parent))
          );
        }

        if (promo_discount) promo_discount.quantity += removedProduct.quantity;
        if (state.mingled_item && !newCart.length) {
          newMingled_item = false;
        }

        return {
          ...state,
          price: newPrice,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          mingled_item: newMingled_item,
          pickup_only_items: Math.max(0, newPickupOnlyItems),
          delivery_only_items: Math.max(0, newDeliveryOnlyItems),
          cash_only_items: Math.max(0, newCashOnlyItems),
          credit_only_items: Math.max(0, newCreditOnlyItems),
        };
      case EDIT_QUANTITY_PROMO:
        cart_product = NewPromoItems[payload.product];
        newPrice = preciseNumber(
          state.price -
            cart_product.total_price *
              (cart_product.quantity - payload.quantity)
        );
        const diff_quantity = payload.quantity - cart_product.quantity;
        cart_product.quantity = payload.quantity;

        if (cart_product?.discountType === "category_free") {
          promo_discount = NewDiscounts.category_free.find(
            (p) =>
              p.id === cart_product.discount && p.promo === cart_product.promo
          );
        } else {
          promo_discount = NewDiscounts.products.find(
            (p) =>
              p.id === cart_product.discount &&
              p.promo === cart_product.promo &&
              ((!p.has_variants && p.product === cart_product.id) ||
                (p.has_variants && p.product === cart_product.parent))
          );
        }
        if (promo_discount) promo_discount.quantity -= diff_quantity;

        return {
          ...state,
          price: newPrice,
          promo_items: NewPromoItems,
          discounts: NewDiscounts,
        };
      case SET_CATEGORIES_MIN_ORDER:
        return {
          ...state,
          categories_min_order: payload || {},
        };

      case SET_IS_PREORDERING_FALSE:
        newCart[payload.product].is_preordered = false;
        newPreorderedItems--;
        return {
          ...state,
          cart: newCart,
          preordered_items: newPreorderedItems,
        };

      case SET_NON_MINGLED_CATEGORY:
        return { ...state, non_mingled_category: payload };

      case "LOAD_CART_JSON":
        return { ...convertToJS(payload) };

      case EDIT_PRODUCT: {
        let product = newCart[payload.productIndex];

        // Check if options has inventory
        ////////////////////////////////////////////////////////////////
        const productOptions = JSON.parse(JSON.stringify(product.options));

        if (payload.options) {
          Object.entries(payload.options).forEach(([optionID, option]) => {
            const productOptionGroup = product.options[optionID];

            Object.entries(option.selectedOptions).forEach(
              ([choiceID, choice]) => {
                if (choice.maxInventory !== null && choice.related_product) {
                  const productOptionChoice =
                    productOptionGroup?.selectedOptions?.[choiceID];

                  const modifersQuantity =
                    (!option.quantityExclusive &&
                      choice.quantity * product.quantity) ||
                    choice.quantity * Math.sign(product.quantity);
                  let modifiersProductQuantity = 0;
                  if (productOptionChoice) {
                    delete productOptions[optionID].selectedOptions[choiceID];
                    if (!productOptions[optionID].selectedOptions)
                      delete productOptions[optionID];
                    modifiersProductQuantity =
                      (!productOptionGroup.quantityExclusive &&
                        productOptionChoice.quantity * product.quantity) ||
                      productOptionChoice.quantity *
                        Math.sign(product.quantity);
                  }

                  if (modifiersProductQuantity - modifersQuantity != 0) {
                    asyncDispatch({
                      type: REDUCE_QUANTITY,
                      payload: {
                        product: choice.related_product || {},
                        change: modifersQuantity - modifiersProductQuantity,
                        isPreordering: false,
                      },
                    });
                  }
                }
              }
            );
          });
        }

        Object.entries(productOptions).forEach(([optionID, option]) => {
          Object.entries(option.selectedOptions).forEach(
            ([choiceID, choice]) => {
              if (choice.maxInventory !== null && choice.related_product) {
                const modifersQuantity =
                  (!option.quantityExclusive &&
                    choice.quantity * product.quantity) ||
                  choice.quantity * Math.sign(product.quantity);

                asyncDispatch({
                  type: REDUCE_QUANTITY,
                  payload: {
                    product: choice.related_product || {},
                    change: -modifersQuantity,
                    isPreordering: false,
                  },
                });
              }
            }
          );
        });

        ///////////////////////////////////////////////////////////////////////////////

        const oldQuantityExcludedTotal = product.quantityExcludedOptionsTotal;
        const oldTotalPrice = product.total_price;
        const oldQuantity = product.quantity;

        newPrice = preciseNumber(
          state.price -
            product.total_price * product.quantity +
            payload.total_price * payload.quantity
        );

        newPrice = preciseNumber(
          newPrice -
            product.quantityExcludedOptionsTotal +
            payload.quantityExcludedOptionsTotal
        );
        const difference_quantity = payload.quantity - product.quantity;

        if (product.booking_slot != payload.booking_slot) {
          asyncDispatch({
            type: REDUCE_QUANTITY,
            payload: {
              product: { ...payload, booking_slot: product.booking_slot },
              change: -product.quantity,
              isPreordering: product.is_preordered,
            },
          });
        }
        if (
          difference_quantity != 0 ||
          product.booking_slot != payload.booking_slot
        ) {
          asyncDispatch({
            type: REDUCE_QUANTITY,
            payload: {
              product: payload,
              change:
                product.booking_slot != payload.booking_slot
                  ? payload.quantity
                  : difference_quantity,
              isPreordering: payload.is_preordered,
            },
          });
        }
        product.quantity = payload.quantity;
        NewNumber_of_items = preciseNumber(
          NewNumber_of_items + difference_quantity
        );

        if (NewNumber_of_items < 0) NewNumber_of_items = 0;

        /// UPDATE
        product.price = payload.price;
        product.total_price = payload.total_price;

        product.quantityExcludedOptionsTotal =
          payload.quantityExcludedOptionsTotal;
        product.options = payload.options;
        product.extraFields = payload.extraFields;
        product.special_request = payload.specialRequest;
        product.booking_slot = payload.booking_slot;

        product.resouce = payload.resource;
        product.resourceSlot = payload.resourceSlot;
        // product.productUsedComponents = payload.productUsedComponents;

        if (smart_promos && smart_promos.length) {
          ({ NewSmart_promos, NewDiscounts, NewPromoItems } = ShouldAddPromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            asyncDispatch,
            newMingled_item,
            newAppliedCoupon,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime,
            customerBin
          ));
        }

        if (NewSmart_promos.length && smart_promos && smart_promos.length) {
          ({
            NewSmart_promos,
            NewDiscounts,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
          } = ShouldRemovePromo(
            smart_promos,
            NewSmart_promos,
            NewDiscounts,
            newPrice,
            NewNumber_of_items,
            newCart,
            NewPromoItems,
            newCharge_delivery,
            newDelivered_items,
            newPreparation_time,
            newAppliedCoupon,
            asyncDispatch,
            customerAddress,
            branchDetails,
            authUser,
            storeCategories,
            storeSettings,
            deliveryTime
          ));
        }

        // //min

        productMinCategories = [product.category_id];
        if (parentCategories) {
          productMinCategories = productMinCategories.concat(parentCategories);
        }
        productMinCategories.forEach((cat) => {
          newCategories_min_order[cat] = preciseNumber(
            (newCategories_min_order[cat] || 0) -
              oldTotalPrice * oldQuantity +
              oldQuantityExcludedTotal
          );

          newCategories_min_order[cat] = preciseNumber(
            (newCategories_min_order[cat] || 0) +
              product.total_price * product.quantity +
              product.quantityExcludedOptionsTotal
          );
        });

        return {
          ...state,
          cart: [...newCart],
          price: newPrice,
          number_of_items: NewNumber_of_items,
          smart_promos: NewSmart_promos,
          discounts: NewDiscounts,
          promo_items: NewPromoItems,
          charged_items: newCharge_delivery,
          delivered_items: newDelivered_items,
          preparation_time: newPreparation_time,
          categories_min_order: newCategories_min_order,
        };
      }

      case "SET_PAYMENT_METHOD": {
        return {
          ...state,
          payment_method: payload,
        };
      }
      case "SET_CART_PRICE": {
        return { ...state, price: payload };
      }
      default:
        return state;
    }
  } catch (err) {
    console.log(err);
    const isLocalhost = Boolean(
      window.location.hostname === "localhost" ||
        window.location.hostname == "192.168.43.120" ||
        window.location.hostname == "192.168.43.74" ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === "[::1]" ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    if (!isLocalhost) {
      instance
        .post("send_error/", {
          error: type + " " + "Cart Reducer",
          info: err.toString(),
          cart_reducer: JSON.stringify(state),
          browser: navigator.userAgent,
        })
        .then(console.log("logged error"));

      let ErrorCount = sessionStorage.getItem("CartReducerErrorCount");
      if (ErrorCount) {
        ErrorCount = parseInt(ErrorCount);

        if (ErrorCount >= 2) {
          instance
            .post("send_error/", {
              error: "cart reducer was reset was reset",
              info: " ",
              browser: navigator.userAgent,
            })
            .then(null);
          sessionStorage.removeItem("CartReducerErrorCount");
          return resetState;
        } else {
          sessionStorage.setItem("CartReducerErrorCount", ErrorCount + 1);
        }
      } else {
        sessionStorage.setItem("CartReducerErrorCount", 1);
      }
    }
    return state;
  }
};

export const migrations = {
  0: (state) => {
    return {
      ...state,
    };
  },
  1: (state) => {
    // migration to keep only device state
    return {
      cart: { ...state.cart, mingled_item: false },
    };
  },
  2: (state) => {
    let number_of_items = 0;
    state.cart.cart.forEach((item) => {
      number_of_items += item.quantity;
    });
    return {
      ...state,
      cart: {
        ...state.cart,
        smart_promos: [],
        discounts: { percent: [], fixed: [], delivery: [], products: [] },
        promo_items: [],
        number_of_items: number_of_items,
      },
    };
  },
  3: (state) => {
    let CartWithPickupField = state.cart.cart;
    let PromoItemsCartWithPickupField = state.cart.promo_items;
    CartWithPickupField = CartWithPickupField.map((item) => {
      return { ...item, pickup_only: false, delivery_only: false };
    });
    PromoItemsCartWithPickupField = PromoItemsCartWithPickupField.map(
      (item) => {
        return { ...item, pickup_only: false, delivery_only: false };
      }
    );

    return {
      ...state,
      cart: {
        ...state.cart,
        cart: CartWithPickupField,
        promo_items: PromoItemsCartWithPickupField,
        pickup_only_items: 0,
        delivery_only_items: 0,
      },
    };
  },
  4: (state) => {
    let cart = state.cart.cart;
    cart.forEach((item) => {
      item.is_preordered = false;
      item.preordering_leadtime = 0;
    });

    return {
      ...state,
      cart: {
        ...state.cart,
        cart: cart,

        preordered_items: 0,
        preordering_max_leadtime: 0,
      },
    };
  },
  5: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        discounts: { ...state.cart.discounts, category: [] },
      },
    };
  },
  6: (state) => {
    let CartWithExtraFields = state.cart.cart;
    let PromoItemsCartWithExtraFields = state.cart.promo_items;
    CartWithExtraFields = CartWithExtraFields.map((item) => {
      return { ...item, extraFields: {} };
    });
    PromoItemsCartWithExtraFields = PromoItemsCartWithExtraFields.map(
      (item) => {
        return { ...item, extraFields: {} };
      }
    );

    return {
      ...state,
      cart: {
        ...state.cart,
        cart: CartWithExtraFields,
        promo_items: PromoItemsCartWithExtraFields,
      },
    };
  },
  7: (state) => {
    let CartWithExcludedOptions = state.cart.cart;
    let PromoItemsCartWithExcludedOptions = state.cart.promo_items;
    CartWithExcludedOptions = CartWithExcludedOptions.map((item) => {
      return { ...item, quantityExcludedOptionsTotal: 0 };
    });
    PromoItemsCartWithExcludedOptions = PromoItemsCartWithExcludedOptions.map(
      (item) => {
        return { ...item, quantityExcludedOptionsTotal: 0 };
      }
    );

    return {
      ...state,
      cart: {
        ...state.cart,
        cart: CartWithExcludedOptions,
        promo_items: PromoItemsCartWithExcludedOptions,
      },
    };
  },
  8: (state) => {
    let categoryDiscounts = state.cart.discounts.category.map((discount) => {
      return { ...discount, categories: [discount.category_id] };
    });

    return {
      ...state,
      cart: {
        ...state.cart,
        discounts: {
          ...state.cart.discounts,
          products_percent: [],
          category: categoryDiscounts,
        },
      },
    };
  },
  9: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        discounts: {
          ...state.cart.discounts,
          modifier: [],
        },
      },
    };
  },
  10: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        discounts: {
          ...state.cart.discounts,
          category_free: [],
        },
      },
    };
  },
  11: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        discounts: {
          ...state.cart.discounts,
          cashback_fixed: [],
          cashback_percent: [],
        },
      },
    };
  },
  12: (state) => {
    return {
      ...state,
      promise: {
        ...state.promise,
        send_gift_anonymously: false,
      },
    };
  },
  13: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        cash_only_items: 0,
        credit_only_items: 0,
      },
    };
  },
  14: (state) => {
    return {
      ...state,
      PastOrders: {
        ...state.PastOrders,
        partOrdersForReOrder: [],
      },
    };
  },
  15: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        delivery_only_items: 0,
      },
    };
  },
  16: (state) => {
    const versionedSmartPromos = state.cart.smart_promos.map((promo) => {
      return { ...promo, version: 1 };
    });

    return {
      ...state,
      cart: {
        ...state.cart,
        smart_promos: versionedSmartPromos,
      },
    };
  },
  17: (state) => {
    return {
      ...state,
      promise: {
        ...state.promise,
        unknown_location: false,
      },
    };
  },
  18: (state) => {
    return {
      ...state,
      promise: {
        ...state.promise,
        gift_wrapping: false,
      },
    };
  },
};
